import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UserManualService } from 'app/core/services/user-manual.service';
import { SharedModule } from 'app/shared/shared.module';
import { UserManualComponent } from './user-manual.component';

@NgModule({
  declarations: [UserManualComponent],
  imports: [CommonModule, SharedModule],
  providers: [UserManualService],
})
export class UserManualModule {}
